import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

import { Button } from "@/components/ui/ui";

import SignUpSignIn from "@/components/user/SignUpSignIn";

import { readDocument, updateDocument } from "@/lib/db";
import { useAuth, updateCookie } from "@/lib/auth";
import { isSignedIn } from "@/components/user/UserUtils";
import { useLocalStorage } from "@/utils/hooks";
import Link from "@/utils/link";
import { createCommunityPortalUser } from "@/components/communityPortal/community/communityUtils";

const CpSignUp = () => {
    const router = useRouter();
    const auth = useAuth();
    const [communities, setCommunities] = useState([]);
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);
    const [signedInOnce, setSignedInOnce] = useLocalStorage("CpSignUp.signedInOnce", false);
    const [user, setUser] = useState({});

    const userId = auth && auth.user ? auth.user.uid : "";
    const token = auth && auth.user ? auth.user.token : "";

    const { company } = router.query;
    console.log("CpSignUp company", company);

    // update the cookie each time we access this component
    useEffect(() => updateCookie(token), [token]);

    useEffect(() => {
        const getUser = async (uid) => {
            const user = await readDocument("users", uid);
            setUser(user);
        };

        if (userId) {
            getUser(userId);
        }
    }, [userId]);

    useEffect(() => {
        const fetchData = async (_token) => {
            const res = await fetch("/api/community-portal/community", {
                method: "GET",
                headers: {
                    token: _token,
                },
            });
            const data = await res.json();
            console.log("CpCommunityConsole data", data);
            setCommunities(data.map((c) => c.community_link));
        };

        if (token) {
            fetchData(token);
        }
    }, [token]);

    const handleSuccessfulSignIn = async (uid, email, name, _token) => {
        const _user = await readDocument("users", uid);

        console.log("CpHomeHeaderMenu handleSignUp", _user);

        if (_user.firstTime) {
            await createCommunityPortalUser(uid, email, _user.name, company);

            // if this is the first time the user has signed in, send a welcome email.
            const res = await fetch("/api/email/community-welcome-to-purple-door-finders", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    token: _token,
                },
                body: JSON.stringify(
                    {
                        title: `Welcome to Purple Door Finders, ${_user.name}!`,
                        preview: `Welcome to Purple Door Finders, ${_user.name}!`,
                        name: _user.name,
                    },
                    null,
                    2
                ),
            });

            await updateDocument("users", uid, {
                ..._user,
                firstTime: false,
            });
        }

        setSignedInOnce(true);

        // reload the page - in case the user tried to reload an expired page
        router.reload();
    };

    const handleGetStarted = () => {
        if (isSignedIn(auth)) {
            //router.push("/community-portal/get-started");

            if (communities.length > 0) {
                // if there are existing communities, go to the console.
                router.push("/community-portal/my-communities");
            } else {
                // otherwise go directly to adding the first community.
                router.push("/community-portal/my-communities/add-community");
            }
        } else {
            if (signedInOnce) {
                setOpenSignIn(true);
            } else {
                setOpenSignUp(true);
            }
        }
    };

    const handleManageMyCommunities = () => {
        if (isSignedIn(auth)) {
            router.push("/community-portal/my-communities");
        } else {
            if (signedInOnce) {
                setOpenSignIn(true);
            } else {
                setOpenSignUp(true);
            }
        }
    };

    let userIsSignedInAndHasCommunities = isSignedIn(auth) && communities.length > 0;
    let theFirstCommunityIsNotPaid = false;

    if (userIsSignedInAndHasCommunities) {
        theFirstCommunityIsNotPaid = communities[0].plan !== "Paid";
    }

    return (
        <div>
            <div className="flex space-x-4">
                <Button
                    color="primary"
                    size="xl"
                    className="uppercase"
                    onClick={
                        userIsSignedInAndHasCommunities
                            ? handleManageMyCommunities
                            : handleGetStarted
                    }
                >
                    {userIsSignedInAndHasCommunities
                        ? "Manage My Communities"
                        : "Get Started"}
                </Button>

                {theFirstCommunityIsNotPaid ? (
                    <Button
                        color="primary"
                        size="xl"
                        className="uppercase bg-red-600 hover:bg-red-700"
                        onClick={handleManageMyCommunities}
                    >
                        Upgrade Now
                    </Button>
                ) : null}
            </div>

            {isSignedIn(auth) ? (
                <div className="mt-2">
                    <span className="">
                        You are currently signed in ({auth.user.email})
                    </span>
                </div>
            ) : (
                <div className="mt-2">
                    <span className="">Already have an account?</span>
                    <button
                        className="ml-4 text-primary-500 font-bold hover:underline"
                        onClick={() => setOpenSignIn(true)}
                    >
                        Sign In
                    </button>
                </div>
            )}

            {userIsSignedInAndHasCommunities ? null : (
                <div className="mt-8">
                    <Link href="https://meetings.hubspot.com/community49">
                        <a
                            className={`px-4 py-4 uppercase text-lg font-bold
                                        border-4 border-primary-500 rounded text-primary-500
                                        hover:bg-primary-500 hover:text-white`}
                        >
                            Schedule a Demo
                        </a>
                    </Link>
                </div>
            )}

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
                onSuccessfulSignIn={handleSuccessfulSignIn}
                nameIsRequired={true}
                communityPortal={true}
            />
        </div>
    );
};

export default CpSignUp;
